// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__pjd6O","col":"styles_col__2dsuZ"};